module.exports = __webpack_public_path__ + "img/96.ece74d89.jpg";